import {CHOOSE_ENDPOINT, ENGAGEMENT_ENDPOINT, EMPTY_CART_DY_DATA} from 'constants/dyData';
import {apiConfig} from 'libs/api/api';

import {DyRecommendationResponseType} from '../types';

import {FetchDyApiPropsType, FetchDyApiDataType} from './types';

/**
 * Function for getting data for recommendation and sending clicks
 * @param {FetchDyApiPropsType} dyApiProps - data for request to DY
 * @returns {Promise<FetchDyApiDataType>} return data from dy and callback for click
 */
export const fetchDyApi = async ({
    args,
    contextData = [],
    selectorName,
    type,
}: FetchDyApiPropsType): Promise<FetchDyApiDataType> => {
    const {data} = await apiConfig.instanceDyChoose.request<DyRecommendationResponseType>({
        data: {
            context: {
                page: {
                    data: contextData,
                    type,
                },
            },
            selector: {
                args,
                names: [selectorName],
            },
        },
        method: 'POST',
        url: CHOOSE_ENDPOINT,
    });

    const sendDyEngagement = (slotId: string) => {
        apiConfig.instanceDyEngagement.request({
            data: {
                engagements: [
                    {
                        decisionId: data?.choices[0]?.decisionId,
                        type: 'CLICK',
                    },
                    {
                        slotId,
                        type: 'SLOT_CLICK',
                    },
                ],
            },
            method: 'POST',
            url: ENGAGEMENT_ENDPOINT,
        });
    };

    const slots = data?.choices[0]?.variations[0]?.payload?.data?.slots;

    const custom = data?.choices[0]?.variations[0]?.payload?.data?.custom;

    return {
        choice: data?.choices[0],
        custom,
        data: slots,
        isReceivedDataEmpty: Boolean(!slots?.length),
        sendDyEngagement,
    };
};

/**
 * Function for request Dy API
 * @returns {Promise<FetchDyApiDataType>} data
 */
export const fetchEmptyCartRecommendations = () => {
    return fetchDyApi({
        selectorName: EMPTY_CART_DY_DATA.selector,
        type: EMPTY_CART_DY_DATA.type,
    });
};
